import { render, staticRenderFns } from "./BnConfirmDialog.vue?vue&type=template&id=6129f7eb&scoped=true&"
import script from "./BnConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./BnConfirmDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6129f7eb",
  null
  
)

export default component.exports